<template>
    <div class="y-checkbox-group">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'y-checkbox-group',
    props: {
        value: {}
    },
    watch: {
        value (value) {
            this.$emit('input', value)
        }
    }
}
</script>


// WEBPACK FOOTER //
// checkbox-group.vue?00ef751e